import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import useGoogleAnalytics from './hooks/useGoogleAnalytics';
import NotFound from "pages/NotFound";
import LandingPage from './pages/landing-page';
import AboutUs from './pages/about-us';
import LoginSelection from './pages/login-selection';
import UserLogin from './pages/user-login';
import BusinessLogin from './pages/business-login';
import AdminLogin from './pages/admin-login';
import AffiliateDashboard from './pages/affiliate-dashboard';
import AffiliateManagement from './pages/affiliate-management';
import UserDashboard from './pages/user-dashboard';
import BusinessDashboard from './pages/business-dashboard';
import BusinessProfile from './pages/business-profile';
import BusinessDirectory from './pages/business-directory';
import UserRegistration from './pages/user-registration';
import BusinessRegistration from './pages/business-registration';
import PaymentVerification from './pages/payment-verification';
import RegistrationPendingVerification from './pages/registration-pending-verification';
import AdminPanel from './pages/admin-panel';
import PasswordRecoveryRequest from './pages/password-recovery-request';
import PasswordRecoveryVerification from './pages/password-recovery-verification';
import FAQ from './pages/faq';
import TermsAndConditions from './pages/terms-and-conditions';
import PrivacyPolicy from './pages/privacy-policy';
import BusinessBenefitsLanding from './pages/business-benefits-landing';
import UserBenefitsLanding from './pages/user-benefits-landing';
import BizznetRewardsProgram from './pages/bizznet-rewards-program';
import BusinessDirectoryBenefitsLanding from './pages/business-directory-benefits-landing';
import UserProfileManagement from './pages/user-profile-management';
import AdminRejectionModal from './pages/admin-rejection-modal';
import PaymentRejectionFeedback from './pages/payment-rejection-feedback';

// Wrapper component to use Google Analytics inside Router context
function RoutesWithAnalytics() {
  useGoogleAnalytics();
  
  return (
    <RouterRoutes>
      {/* Define your route here */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/landing-page" element={<LandingPage />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/business-benefits-landing" element={<BusinessBenefitsLanding />} />
      <Route path="/user-benefits-landing" element={<UserBenefitsLanding />} />
      <Route path="/bizznet-rewards-program" element={<BizznetRewardsProgram />} />
      <Route path="/business-directory-benefits-landing" element={<BusinessDirectoryBenefitsLanding />} />
      <Route path="/login-selection" element={<LoginSelection />} />
      <Route path="/user-login" element={<UserLogin />} />
      <Route path="/business-login" element={<BusinessLogin />} />
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route path="/password-recovery-request" element={<PasswordRecoveryRequest />} />
      <Route path="/password-recovery-verification" element={<PasswordRecoveryVerification />} />
      <Route path="/affiliate-dashboard" element={<AffiliateDashboard />} />
      <Route path="/affiliate-management" element={<AffiliateManagement />} />
      <Route path="/user-dashboard" element={<UserDashboard />} />
      <Route path="/business-dashboard" element={<BusinessDashboard />} />
      <Route path="/business-profile" element={<BusinessProfile />} />
      <Route path="/business-directory" element={<BusinessDirectory />} />
      <Route path="/user-registration" element={<UserRegistration />} />
      <Route path="/business-registration" element={<BusinessRegistration />} />
      <Route path="/registration-pending-verification" element={<RegistrationPendingVerification />} />
      <Route path="/payment-verification" element={<PaymentVerification />} />
      <Route path="/admin-panel" element={<AdminPanel />} />
      <Route path="/admin-rejection-modal" element={<AdminRejectionModal />} />
      <Route path="/payment-rejection-feedback" element={<PaymentRejectionFeedback />} />
      <Route path="/user-profile-management" element={<UserProfileManagement />} />
      <Route path="*" element={<NotFound />} />
    </RouterRoutes>
  );
}

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RoutesWithAnalytics />
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;